import GovGrTableAction from "./GovGrTableAction";
import GovGrTableActions from "./GovGrTableActions";
import GovGrTableBody from "./GovGrTableBody";
import GovGrTableBodyRow from "./GovGrTableBodyRow";
import GovGrTableCell from "./GovGrTableCell";
import GovGrTableContainer from "./GovGrTableContainer";
import GovGrTableHeader from "./GovGrTableHeader";
import GovGrTableLoader from "./GovGrTableLoader";
import GovGrTablePagination from "./GovGrTablePagination";
import GovGrTableToolbar from "./GovGrTableToolbar";

const components = {
  Action: GovGrTableAction,
  Actions: GovGrTableActions,
  Body: GovGrTableBody,
  Cell: GovGrTableCell,
  Container: GovGrTableContainer,
  // EditFild: EmptyComponent,
  // EditRow: EmptyComponent,
  // FilterRow: EmptyComponent,
  // GroupBar: EmptyComponent,
  Header: GovGrTableHeader,
  OverlayLoading: GovGrTableLoader,
  Pagination: GovGrTablePagination,
  Row: GovGrTableBodyRow,
  Toolbar: GovGrTableToolbar,
};

export default components;
